import React, { useEffect, useState } from "react";
import { supabase } from "../../supabase-client";
import { Plus, Pencil, CircleX, ArrowLeft } from "lucide-react";

function Tablas() {
   const [tasks, setTasks] = useState([]);
   // const [filtro, setFiltro] = useState("");
   const [change, setChange] = useState(false);
   const fetchTasks = async () => {
      const { error, data } = await supabase
         .from("tabla")
         .select("*")
         .order("cod", { ascending: true })
         .order("orden", { ascending: true })
         ;

      if (error) {
         console.error("Error reading task: ", error.message);
         return;
      }

      setTasks(data);
   };
   useEffect(() => {
      fetchTasks();
   }, [change]);

   console.log("data: ", tasks);

   // const [records, setRecords] = useState(tasks);
   const [selectedCod, setSelectedCod] = useState("");
   const [editRecord, setEditRecord] = useState(null);

   const filters = tasks.filter((item) => item.orden === 1);
   console.log("filters: ", filters);

   const filteredRecords = selectedCod
      ? tasks.filter(
           (item) => item.cod === Number(selectedCod) && item.orden > 1
        )
      : [];

   const maxOrden = Math.max(
      ...filteredRecords
         .filter((item) => item.cod === Number(selectedCod))
         .map((item) => item.orden)
   );

   const handleSave = async () => {
      console.log("maxOrden: ", maxOrden);
      console.log("editRecord: ", editRecord);
      if (!editRecord.orden) {
         editRecord.orden = maxOrden + 1;
         editRecord.cod = Number(selectedCod);
         const { error } = await supabase.from("tabla").insert(editRecord);
         if (error) {
            console.log("error ", error);
            alert(error.message);
            return;
         }
         setChange(!change);
      } else {
         const { error } = await supabase
            .from("tabla")
            .update({ descripcion: editRecord.descripcion })
            .eq("id", editRecord.id);

         if (error) {
            console.log("error ", error);
            alert(error.message);
            return;
         }
         setChange(!change);
      }
      console.log("editRecord: ", editRecord);

      //   setRecords((filteredRecords) =>
      //     filteredRecords.map((rec) => (rec.id === editRecord.id ? editRecord : rec))
      // );
      console.log("handleSave: ", filteredRecords);
      setEditRecord(null);
   };

   const handleDelete = async (id) => {
      const { error } = await supabase.from("tabla").delete().eq("id", id);

      if (error) {
         console.log("error ", error);
         alert(error.message);
         return;
      }
      setChange(!change);
   };

   return (
      <div className="p-6 max-w-xl mx-auto">
         <h1 className="text-2xl font-bold mb-4">Filtro de Registros</h1>

         {/* Filter Select */}
         <label className="block mb-2 text-sm font-medium text-gray-700">
            Selecciona un filtro:
         </label>
         <select
            className="w-full p-2 border rounded-lg shadow-sm focus:ring focus:ring-blue-300"
            value={selectedCod}
            onChange={(e) => setSelectedCod(e.target.value)}
         >
            <option value="">-- Seleccionar --</option>
            {filters.map((f) => (
               <option key={f.id} value={f.cod}>
                  {f.descripcion}
               </option>
            ))}
         </select>

         {/* Results Table */}
         {filteredRecords.length > 0 && (
            <div className="mt-6">
               <div className="flex justify-between">
                  <h2 className="text-lg font-semibold mb-3">Resultados:</h2>
                  <button
                     onClick={() => setEditRecord({})}
                     className="btn-green"
                  >
                     <Plus className="lucid-icons-blue" /> Nuevo
                  </button>
               </div>
               <table className="w-full border border-gray-300 rounded-lg overflow-hidden">
                  <thead className="bg-gray-200 text-gray-700">
                     <tr>
                        <th className="p-2 text-left">ID</th>
                        <th className="p-2 text-left">Descripción</th>
                        <th className="p-2 text-left">Orden</th>
                        <th className="p-2 text-left">Acciones</th>
                     </tr>
                  </thead>
                  <tbody>
                     {filteredRecords.map((rec) => (
                        <tr key={rec.id} className="border-t hover:bg-gray-50">
                           <td className="p-2">{rec.id}</td>
                           <td className="p-2  text-left">{rec.descripcion}</td>
                           <td className="p-2">{rec.orden}</td>
                           <td className="p-2 flex gap-2">
                              <button
                                 onClick={() => setEditRecord({ ...rec })}
                                 className="btn-green"
                              >
                                 <Pencil className="lucid-icons-blue" /> Editar
                              </button>
                              <button
                                 onClick={() => handleDelete(rec.id)}
                                 className="btn-red"
                              >
                                 <CircleX className="lucid-icons-red" /> Borrar
                              </button>
                           </td>
                        </tr>
                     ))}
                  </tbody>
               </table>
            </div>
         )}

         {/* Modal */}
         {editRecord && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40">
               <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                  <h2 className="text-xl font-bold mb-4">Editar Registro</h2>

                  <label className="block mb-2 text-sm font-medium text-gray-700">
                     Descripción
                  </label>
                  <input
                     type="text"
                     className="w-full p-2 border rounded mb-4"
                     value={editRecord.descripcion}
                     onChange={(e) =>
                        setEditRecord({
                           ...editRecord,
                           descripcion: e.target.value,
                        })
                     }
                  />

                  <div className="flex justify-end gap-3">
                     <button
                        onClick={() => setEditRecord(null)}
                        className="btn-gray-light"
                     >
                        <ArrowLeft className="lucid-icons" /> Volver
                     </button>
                     <button onClick={handleSave} className="btn-green">
                        <Plus className="lucid-icons-blue" /> Guardar
                     </button>
                  </div>
               </div>
            </div>
         )}
      </div>
   );
}

export default Tablas;
